@if (visible) {
  <div data-inactivityLogoutBannerComponent role="status">
    <p>{{ "banner.inactivity.logout.message" | translate | async }}</p>
    <button type="button" class="dismiss-link" (click)="dismiss()">
      {{ "banner.inactivity.logout.dismiss" | translate | async }}
    </button>
  </div>
}
